export default __webpack_public_path__ + "static/media/icon_finishingtype_BrushSatin.a2d3799f.png";